import React, { Fragment, Component, useState } from 'react';
import { translate } from '../Services/translation';
import FacetedSearchDlx from './FacetedSearchDlx'; 

class FacetedSearchGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: false,
            showLessItemCount : 5,
        };
        this.toggleShowMore = this.toggleShowMore.bind(this);
        this.checkIfSpanExists = this.checkIfSpanExists.bind(this);
    }

    componentDidMount() {
        const visible = this.refs.list.getBoundingClientRect().height !== 0;
        const tooMuchItem = this.props.group.options.filter(option => option.id && option.quantity > 0).length > this.state.showLessItemCount;
        visible && tooMuchItem && this.toggleShowMore();
    }

    componentDidUpdate(){
        if(this.checkIfSpanExists(this.props.group.id) < this.state.showLessItemCount) {
            const setHeight = () => this.refs.list.style.height = '';
            setHeight();
        }
        else{
            const topPos = this.refs.list ? this.refs.list.getBoundingClientRect().top : null;
            const lessBottomPos = this.refs.showLess ? this.refs.showLess.getBoundingClientRect().bottom: null;
            const moreBottomPos = this.refs.showMore ? this.refs.showMore.getBoundingClientRect().bottom: null; 

            if(topPos && lessBottomPos && moreBottomPos){
                const setHeight = () => this.refs.list.style.height = `${ (this.state.collapsed ? lessBottomPos : moreBottomPos ) - topPos }px`;
                const toggleCollapse = () => {
                        setHeight()
                    };           
                if( !this.refs.list.style.height ) {
                    setHeight();
                    setTimeout(()=> {toggleCollapse()}, 0);
                }
                else {
                    toggleCollapse();
                }   
            }  
        }
    }

    toggleShowMore() {
        const topPos = this.refs.list ? this.refs.list.getBoundingClientRect().top : null;
        const lessBottomPos = this.refs.showLess ? this.refs.showLess.getBoundingClientRect().bottom: null;
        const moreBottomPos = this.refs.showMore ? this.refs.showMore.getBoundingClientRect().bottom: null; 

        if(topPos && lessBottomPos && moreBottomPos){
            const setHeight = () => this.refs.list.style.height = `${ (this.state.collapsed ? lessBottomPos : moreBottomPos ) - topPos }px`;
            const toggleCollapse = () => {
                this.setState((prevState, props) => ({
                    collapsed: !prevState.collapsed
                }),()=> {
                    setHeight();
                });
            }
            if( !this.refs.list.style.height ) {
                setHeight();
                setTimeout(()=> {toggleCollapse()}, 0);
            }
            else {
                toggleCollapse();
            }   
        }  
    }

    checkIfSpanExists(id) {
        const divElement = document.getElementById(`faceted-search__group__container${id}`);
        if (divElement) {
          const ulElement = divElement.querySelector('ul');
          if (ulElement) {
            const liElements = ulElement.getElementsByTagName('li');
            return liElements.length;
          }
        }
        return 0;
      }

    showMore(group) {
        return group.options
            && group.options.filter(option => option.id && option.quantity > 0).length > 0
            && group.options.filter(option => option.id && option.quantity > 0).length > this.state.showLessItemCount;
    }

    render() {
        const { group, searchFacetChange } = this.props;
        return (
            <div className="faceted-search__group__container" id={`faceted-search__group__container${group.id}`}>
                <ul className="faceted-search__group" ref="list">
                {group.options && group.options.some(option => option.id && option.quantity > 0) && (
                    <Fragment>
                        <div className="faceted-search__group-header" role="faceted-search-item-group">{ group.label }</div>
                        {group.options.filter(option => option && option.id && option.quantity > 0).map((item, itemIndex, array) => (
                             item && item.id && item.quantity >0 && (
                                <li key={`${item.label}-${itemIndex}`} 
                                className="faceted-search__item" 
                                role="faceted-search-item" 
                                ref={ itemIndex === this.state.showLessItemCount - 1   ? "showLess"   : itemIndex===array.length-1 ? "showMore" : null}>
                                    <FacetedFilterCheckbox item={item} group={group} searchFacetChange={searchFacetChange} />
                                </li>
                             )
                        ))}
                    </Fragment>
                    )
                }
                </ul>
                { this.showMore(group) 
                    &&
                    <span id={`faceted-search__show-more${group.id}`} className="faceted-search__show-more" onClick={this.toggleShowMore}>
                        {`${ this.state.collapsed ? translate('filter.showmore') : translate('filter.showless')}`}
                    </span>
                }
            </div>
        )
    }
}

const FacetedSearch = ({ facetFilters, searchFacetChange, navigationTheme }) => {
    return facetFilters && facetFilters.length > 0 && (
    <FacetedSearchDlx
        facetFilters={facetFilters}
        navigationTheme={navigationTheme}
        searchFacetChange={searchFacetChange}
    />
    );
};
  
const FacetedFilterCheckbox = ({ item, group, searchFacetChange }) => {
    const handleCheckboxChange = () => {
        searchFacetChange(group, item);
    };

    return ( item.id && item.quantity > 0 && (
        <label className="faceted-filter" >
            <input 
            className="faceted-filter__input" 
            type="checkbox" 
            onChange={handleCheckboxChange} 
            checked={group.selectedOptions != null && group.selectedOptions.includes(item.id)} />
            <span className="faceted-filter__label">
                {item.label}
            {!isNaN(item.quantity) && (item.quantity != null) && 
                    <span className="faceted-filter__quantity">&nbsp;({item.quantity})</span>
                }
            </span>
        </label>
    ))
}

export default FacetedSearch;
